<i (click)="toggle()" class="fa-star favourite-icon" [ngClass]="isFavourite ? 'fas' : 'far'"></i>
